import React, { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar, faBolt, faAward } from '@fortawesome/free-solid-svg-icons'
import { formatDate } from '../helpers/format'

library.add(faStar, faBolt, faAward)

export type RatingStats = {
    ratingAvg?: number | null
    ratingCount?: number
    energyAvg?: number | null
    energyCount?: number
    importanceAvg?: number | null
    importanceCount?: number
}

/** The "Average ratings" line: a count link per rating field that has any values in range. */
const ExploreRatings = (props: { stats: RatingStats, from?: number, until?: number }): ReactElement | null => {
    const shown = [
        { field: 'rating', icon: 'star' as const, avg: props.stats.ratingAvg, count: props.stats.ratingCount ?? 0 },
        { field: 'energy', icon: 'bolt' as const, avg: props.stats.energyAvg, count: props.stats.energyCount ?? 0 },
        { field: 'importance', icon: 'award' as const, avg: props.stats.importanceAvg, count: props.stats.importanceCount ?? 0 }
    ].filter(r => r.count > 0)
    if (!shown.length) {
        return null
    }
    const dateParams = (props.from ? `&from=${formatDate(props.from)}` : '')
      + (props.until ? `&until=${formatDate(props.until)}` : '')
    return <p>Average ratings:{' '}
        { shown.map((r, i) => <React.Fragment key={ r.field }>
            { i > 0 && <span className="separator" /> }
            <Link to={ `/entries/by/${r.field}?order=${r.field}&direction=desc${dateParams}` }>{ `${r.count}×` }</Link>
            { ` ~${(r.avg ?? 0).toFixed(1)} ` }
            <FontAwesomeIcon icon={ r.icon } />
        </React.Fragment>) }
    </p>
}

export default ExploreRatings
